import { module as BaseModule } from 'modujs'
import gsap from 'gsap'
import { set } from 'immutable'
export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.scrollPrev = window.scrollY
    this.scrollOffset = 0
    this.offset = 0

    this.reverse = null

    this.initEventlisteners()
  }

  initEventlisteners() {
    window.addEventListener('scroll', () => {
      if (window.innerWidth <= 1024) return
      this.scrollOffset = window.scrollY - this.scrollPrev
      this.parallax()
      this.scrollPrev = window.scrollY
    })
  }

  parallax() {
    const rect = this.el.getBoundingClientRect()
    const position = rect.top
    const start = window.innerHeight - this.el.offsetHeight
    const end = 0 - this.el.offsetHeight

    const MAX_OFFSET = this.el.offsetHeight * 0.35
    const MIN_OFFSET = -this.el.offsetHeight * 0.25

    if (position < start && position > end) {
      // const offset = (1 - position / start) * offset
      this.offset = Math.min(
        Math.max(this.offset + this.scrollOffset * 0.5, MIN_OFFSET),
        MAX_OFFSET
      )

      gsap.to(this.el, {
        duration: 0.2,
        y: this.offset,
        ease: 'none',
      })

      clearTimeout(this.reverse)
      this.reverse = setTimeout(() => {
        this.offset = 0
        gsap.to(this.el, { duration: 0.5, y: this.offset, ease: 'none' })
      }, 800)
    }
  }
}
